module.exports = __webpack_public_path__ + "04dcfb14c9d588df4ded2bbf85948bd3.pdf";